module.exports = __webpack_public_path__ + "img/wa-gb-fitur-utama.53dc7885.webp";